export default __webpack_public_path__ + "static/media/analytics-marketing-team-4.9f313986.svg";